import { render, staticRenderFns } from "./SPRequirementStatus.vue?vue&type=template&id=dc0dad28&"
import script from "./SPRequirementStatus.vue?vue&type=script&lang=js&"
export * from "./SPRequirementStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports